/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Affiliate URL click-through override
  document.addEventListener('click', function(e) {
    const productBlock = e.target.closest('[data-product-block]');
    if (!productBlock) return;
    
    const affiliateLink = productBlock.querySelector('a.product-grid-item__title');
    if (!affiliateLink) return;
    
    const href = affiliateLink.getAttribute('href');
    if (!href || href.includes('love-birdie') || href.startsWith('/')) return;
    
    e.preventDefault();
    e.stopPropagation();
    window.open(href, '_blank');
  });
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
